import React, { Component } from "react";
import { translate } from "../../../utils/useful";
import DropHandles from "./DropHandlers";
import PageSection from "./PageSection";
import RowContent from "./RowContent";
import SingleRow from "./SingleRow";
import ToolBox from "./ToolBox";

class FormsContainer extends Component {
    state = {
        displayHandlers: false
    };

    showDropZone = () => {
        this.setState({ displayHandlers: true });
    };

    render() {
        const {
            setSectionRows,
            showhandlers,
            showhandlersFunc,
            hideHandlersFunc,
            addnewItem,
            changeInputPosition,
            deleteInput,
            openInputConfig,
            pageSections
        } = this.props;

        return (
            <div className="form-column forms scroll-no-scrollbar h-100 px-1 pt-1 pb-5">
                <div className="w-100 px-2 flexcb">
                    {/* <p className="text-semibold text-semibig">From Name</p> */}

                    {/* <button onClick={() => { }} className='px-1 py-1  flexcc mt-1' style={{ filter: !this.state.type == null ? 'saturate(20%) ' : '', background: 'linear-gradient(to right,#9564FE, #7064FE)', borderRadius: 8, color: '#fff', transition: 'all 0.5s' }}>
                        <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>{translate("Save Form")}</p>
                        <div className='flexcc mld-3 p-1' style={{ background: 'linear-gradient(to right, #ffffff10, #ffffff20)', borderRadius: 8 }}>
                            <img className='invert' src='/assets/icons/useful/save.svg' height={18} />
                        </div>
                    </button> */}
                </div>

                {pageSections.map((section) => {
                    const { sectionId, formsRows } = section;
                    let sectionRowsLength = formsRows.length;
                    return (
                        <PageSection
                            setSectionRows={setSectionRows}
                            sectionRowsLength={sectionRowsLength}
                            sectionId={sectionId}
                            key={sectionId}
                            formsRows={formsRows}
                            inputClass={this.props.inputClass}
                            formClass={this.props.formClass}
                            addnewItem={addnewItem}
                            openInputConfig={openInputConfig}
                            changeInputPosition={changeInputPosition}
                            deleteInput={deleteInput}
                            displayHandlers={this.state.displayHandlers}
                            setDisplayHandlers={() =>
                                this.setState({ displayHandlers: true })
                            }
                        />
                    );
                })}
            </div>
        );
    }
}

export default FormsContainer;
